import { EVENTS_APP_ID } from './app-definitions';
export var getBillingUrl = function (msid, referral) {
    return "https://www.wix.com/store/plans?v=1&appDefId=".concat(EVENTS_APP_ID, "&siteGuid=").concat(msid).concat(referral ? "&referralAdditionalInfo=".concat(referral) : '', "#/");
};
export var draftEventPreviewUrlQueryParamName = 'draftPreviewToken';
export var DASHBOARD_PATHS = {
    MY_EVENTS: '',
    NEW_EVENT: '/new',
    EVENT_DETAILS: function (eventId) { return "".concat(eventId, "/event-details"); },
    GUEST_LIST: function (eventId) { return "".concat(eventId, "/guest-list"); },
    DRAFTS: '/drafts',
    CATEGORIES: '/categories',
    OCCURRENCES: '/occurrences',
};
//# sourceMappingURL=urls.js.map